import React from 'react';
import { Button } from 'reactstrap';

const QuestionList = ({ data, onSelect, selected, userData }) => {
  const renderQuestion = React.useCallback(
    (item, index) => {
      const answered = userData.find((x) => x.id === item.id);
      return (
        <div key={item.id} className='col-4' style={{ textAlign: 'center' }}>
          <Button
            onClick={() => onSelect(item.id)}
            style={{
              borderRadius: 50,
              width: 40,
              height: 40,
              fontSize: 18,
              border: 'none',
              display: 'flex',
              fontWeight: 650,
              margin: '10px auto',
              alignItems: 'center',
              justifyContent: 'center',
              color: answered ? '#5F61CF' : '',
              background: answered ? '#B9C4F2' : '',
              boxShadow: selected === index ? '1px 1px 6px 1px blue' : '1px 1px 6px 1px gray',
            }}
          >
            {index + 1}
          </Button>
        </div>
      );
    },
    [onSelect, selected, userData],
  );

  return (
    <div>
      <div style={{ textAlign: 'center', fontWeight: 600, margin: 20 }}>Đã trả lời: {`${userData.length}/${data.length}`} câu</div>
      <div className='row' style={{ textAlign: 'center', maxHeight: 'calc(100vh - 340px)', overflowY: 'auto' }}>
        {data.map(renderQuestion)}
      </div>
    </div>
  );
};

export default QuestionList;
